import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 10"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"4\" cy=\"2\" r=\"1.5\"></circle><circle cx=\"10\" cy=\"2\" r=\"1.5\"></circle><circle cx=\"16\" cy=\"2\" r=\"1.5\"></circle><circle cx=\"4\" cy=\"8\" r=\"1.5\"></circle><circle cx=\"10\" cy=\"8\" r=\"1.5\"></circle><circle cx=\"16\" cy=\"8\" r=\"1.5\"></circle>", 6)
  ]))]))
}
export default { render: render }